

const ABSOLUTE_URL_REGEXP = new RegExp('^(?:[a-z]+:)?//', 'i');

function isUrlAbsolute(url) {
    return ABSOLUTE_URL_REGEXP.test(url);
}

module.exports = isUrlAbsolute;
